module.exports = __webpack_public_path__ + "static/media/top-teachers-video.ff367ec8.mp4";